module.exports = __webpack_public_path__ + "media/images/icons/SVG/037-7eb4457ee3e4331fc7e6f1ebbde1a099.svg";